import * as api from './middleware/api.middleware';
import {
    IIdentityType,
    IIdentityItem,
    IIndentityLookupRequest,
    IUserIdLookupRequest,
} from '../interfaces/userIdentity.interfaces';
import { IResponseCollection } from '../interfaces/general.interfaces';

const serviceUrl = '/useridentityservice/v2';

export const getIdentityTypes = (): Promise<IResponseCollection<IIdentityType>> => {
    return api.get<IResponseCollection<IIdentityType>>(`${serviceUrl}/user-identity-types`);
};

export const getUserIdentities = (userId: number): Promise<IResponseCollection<IIdentityItem>> => {
    return api.get<IResponseCollection<IIdentityItem>>(`${serviceUrl}/user-identities?userId=${userId}`);
};

export const lookupIndentity = (lookupData: IIndentityLookupRequest): Promise<Array<IIdentityItem>> => {
    return api.get<Array<IIdentityItem>>(
        `${serviceUrl}/user-identities/look-up-identity?userId=${lookupData.userId}&identityTypeId=${lookupData.identityTypeId}`
    );
};

export const lookupUserId = (lookupData: IUserIdLookupRequest): Promise<Array<IIdentityItem>> => {
    return api.post<Array<IIdentityItem>>(`${serviceUrl}/user-identities/look-up`, lookupData);
};
